import {cn} from '@utils';

function Skeleton({className, ...props}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted bg-beige-500*', className)}
      {...props}
    />
  );
}

export {Skeleton};
